import { createAction } from 'redux-actions'
import {
  HIDE_LOADER,
  SHOW_LOADER,
  OPEN_LEFT_NAVIGATION,
  CLOSE_LEFT_NAVIGATION,
  GET_USER_SESSION_TOKEN,
  GET_USER_SESSION_TOKEN_FAILED,
  GET_USER_SESSION_TOKEN_SUCCEEDED,
  ENABLE_PAGE_MODE_LOADER,
  DISABLE_PAGE_MODE_LOADER,
  FETCH_USER_FINANCIAL_DATA,
  FETCH_USER_FINANCIAL_DATA_FAILED,
  FETCH_USER_FINANCIAL_DATA_SUCCESS,
} from 'Redux/Types/GlobalTypes'

export const hideLoader = createAction(HIDE_LOADER)
export const showLoader = createAction(SHOW_LOADER)

export const openLeftNavigation = createAction(OPEN_LEFT_NAVIGATION)
export const closeLeftNavigation = createAction(CLOSE_LEFT_NAVIGATION)

export const getUserSessionToken = createAction(GET_USER_SESSION_TOKEN)
export const getUserSessionTokenFailed = createAction(GET_USER_SESSION_TOKEN_FAILED)
export const getUserSessionTokenSucceeded = createAction(GET_USER_SESSION_TOKEN_SUCCEEDED)

export const enablePageModeLoader = createAction(ENABLE_PAGE_MODE_LOADER)
export const disablePageModeLoader = createAction(DISABLE_PAGE_MODE_LOADER)

export const fetchUserFinancialData = createAction(FETCH_USER_FINANCIAL_DATA)
export const fetchUserFinancialDataFailed = createAction(FETCH_USER_FINANCIAL_DATA_FAILED)
export const fetchUserFinancialDataSuccess = createAction(FETCH_USER_FINANCIAL_DATA_SUCCESS)
